export default __webpack_public_path__ + "static/media/photo3.db98448f.jpg";